import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MarvValidatorsService {
    
    constructor() { }
    
    static isInteger(value: any): boolean{
        let check = false;
        if (value !== null ) {
            check = Number.isInteger(parseInt(value.toString()));
        }
        return check;
    }
}
